import { useState, useEffect, useCallback } from 'react';
import { getChannels, getOutputs } from '../../utilities/mezzanineApi';

const useMezzanineData = (options = {}) => {
  const { autoFetch = true, pollingInterval = null } = options;
  
  const [channels, setChannels] = useState([]);
  const [outputs, setOutputs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const outputsByChannelId = outputs.reduce((map, output) => {
    if (!map[output.channel_id]) {
      map[output.channel_id] = [];
    }
    map[output.channel_id].push(output);
    return map;
  }, {});

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    
    try {
      const [channelsResponse, outputsResponse] = await Promise.all([
        getChannels(),
        getOutputs()
      ]);
      
      setChannels(channelsResponse.channels || []);
      setOutputs(outputsResponse.outputs || []);
    } catch (err) {
      console.error('Error fetching Mezzanine data:', err);
      setError(err.message || 'Failed to fetch data');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (autoFetch) {
      fetchData();
    }
  }, [autoFetch, fetchData]);

  useEffect(() => {
    if (pollingInterval && pollingInterval > 0) {
      const interval = setInterval(fetchData, pollingInterval);
      return () => clearInterval(interval);
    }
  }, [pollingInterval, fetchData]);

  return {
    channels,
    outputs,
    outputsByChannelId,
    loading,
    error,
    refetch: fetchData
  };
};

export default useMezzanineData;
